import { TimeBucketSet } from '../../../Reports/types';
import { Field } from '../../types';

export const hasTimeBucket = (value: string) => TimeBucketSet.has(value);

export const filterTimeBucketFromDimensions = (dims: Field[]) => dims.filter(({ name }) => !hasTimeBucket(name));
